<template>
    <div>
        <div class="form-group">
            <label>Company ID</label>
            <input type="text" class="form-control" v-model="data.companyId">
        </div>
        <div class="form-group">
            <label>Tracking Link ID</label>
            <input type="text" class="form-control" v-model="data.trackingLinkId">
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: [
        'data'
    ],
    data() {
        return {};
    }
}
</script>
